import React from 'react';

const Preloader = () => {
  return (
    <div className='cus_container2 center-align'>
      <div className='progress pink lighten-4 '>
        <div className='indeterminate pink '></div>
      </div>
    </div>
  );
};

export default Preloader;
